import type { FaireProductEntity } from "../../entity_types/product";

export const p_5anmzuwm58: FaireProductEntity = {
  token: "p_5anmzuwm58",
  type: "product",
  name: "Purple Fluorite Crab Carving",
  brandToken: "b_gbfbknczne",
  brandName: "Crystal Deal· Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/db47fc42f90786d9d21be5216571628b85f905291f58074a561b61955bf04545.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd8edc41f8f051ce49e01db4315ed30a5dbd4e28ee0b235b2ca704bb38d756d3.jpeg",
    "https://cdn.faire.com/fastly/279d8fc4ddb6ae00886a7b2748a974f7b8f8d2bbb01c2330b53fa7b0002e33f3.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "This listing is for 1 purple Fluorite Crab Carving. Each carving is 2 inches. You will get one carving similar to the ones in the picture.\n\nPurple Fluorite Crab Carving\n\nHand-carved purple fluorite crab with polished details and natural color variations that make each piece one of a kind. This playful ocean-inspired carving is perfect for summer-themed displays, coastal décor collections, and crystal gift assortments. The crab is commonly associated with the Cancer zodiac sign, adding strong appeal for astrology lovers and zodiac-focused merchandising. A fun yet meaningful piece for seasonal and year-round retail.\n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:10.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
